
<script>
import moment from 'moment'

export default {
  name: 'RexDate',
  props: {
    name: {
      type: String,
      default: () => null,
      required: true
    },
    storeModule: {
      type: String,
      default: () => null,
      required: true
    },
    target: {
      type: String,
      default: () => null,
      required: true
    },
    getter: {
      type: String,
      default: () => 'getField'
    },
    setter: {
      type: String,
      default: () => 'setField'
    },
    rangeTargets: {
      type: Array,
      default: () => [
        'startDate',
        'endDate'
      ]
    },
    label: {
      type: String,
      default: () => null
    },
    placeholder: {
      type: String,
      default: () => null
    },
    validate: {
      type: [String, Object],
      default: () => null
    },
    position: {
      type: String,
      default: () => null
    },
    unselectableDates: {
      type: Array,
      default: () => null
    },
    unselectableDaysOfWeek: {
      type: Array,
      default: () => null
    },
    selectableDates: {
      type: Array,
      default: () => null
    },
    minDate: {
      type: Date,
      default: () => moment().toDate()
    },
    maxDate: {
      type: Date,
      default: () => moment().add(5, 'years').toDate()
    },
    events: {
      type: Array,
      default: () => []
    },
    yearsRange: {
      type: Array,
      default: () => null
    },
    legend: {
      type: Array,
      default: () => []
    },
    tooltipText: {
      type: String,
      default: () => ''
    },
    tooltipPosition: {
      type: String,
      default: () => 'is-top'
    },
    hasBackendValidation: {
      type: Boolean,
      default: () => false
    },
    allowNullDate: {
      type: Boolean,
      default: () => false
    },
    isRange: {
      type: Boolean,
      default: () => false
    },
    isLoading: {
      type: Boolean,
      default: () => false
    },
    isDisabled: {
      type: Boolean,
      default: () => false
    },
  },
  inject: ['$validator'],
  computed: {
    value: {
      get() {
        let date

        if (this.isRange) {
          const startDate = this.$store.getters[`${this.storeModule}/${this.getter}`](this.target)[this.rangeTargets[0]]
          const endDate = this.$store.getters[`${this.storeModule}/${this.getter}`](this.target)[this.rangeTargets[1]]

          date = startDate === null || endDate === null
            ? []
            : [
              moment(startDate, 'DD.MM.YYYY').toDate(),
              moment(endDate, 'DD.MM.YYYY').toDate()
            ]
        } else {
          date = this.$store.getters[`${this.storeModule}/${this.getter}`](this.target)

          if (date === null) {
            if (!this.allowNullDate) {
              date = moment().add(3, 'days').toDate()
            }
          } else {
            date = moment(date, 'DD.MM.YYYY').toDate()
          }
        }

        return date
      },
      set(value) {
        if (this.isRange) {
          let [startDate, endDate] = value

          startDate = moment(startDate).format('DD.MM.YYYY')
          endDate = moment(endDate).format('DD.MM.YYYY')

          this.$store.commit(`${this.storeModule}/${this.setter}`, {
            target: `${this.target}.${this.rangeTargets[0]}`,
            value: startDate
          })
          this.$store.commit(`${this.storeModule}/${this.setter}`, {
            target: `${this.target}.${this.rangeTargets[1]}`,
            value: endDate
          })

          this.$emit('сhange', {
            event: {
              startDate,
              endDate
            },
            element: this.$vnode.elm
          })
        } else {
          this.$store.commit(`${this.storeModule}/${this.setter}`, {
            target: this.target,
            value: moment(value).format('DD.MM.YYYY')
          })

          if (this.error !== null && this.hasBackendValidation) {
            const target = this.target.split('.')
            const err = this.$store.getters[`${this.storeModule}/${this.getter}`](`${target[0]}Errors`)
            const currentFieldErrorIndex = err.map(x => x.source).indexOf(this.name)

            err.splice(currentFieldErrorIndex, 1)

            this.$store.commit(`${this.storeModule}/${this.setter}`, err)
          }

          this.$emit('change', {
            event: moment(value).format('DD.MM.YYYY'),
            element: this.$vnode.elm
          })
        }
      }
    },
    error() {
      let error = null

      if (this.hasBackendValidation) {
        const target = this.target.split('.')
        const err = this.$store.getters[`${this.storeModule}/${this.getter}`](`${target[0]}Errors`)
          .find(item => item.source === this.name)

        error = err ? err.detail : null
      }

      return error
    }
  }
}
</script>

<template>
  <b-field
    :label="label"
    custom-class="rex-label"
    :type="{'is-danger': errors.has(name) || error}"
    :message="errors.first(name) || error"
  >
    <b-tooltip
      :label="tooltipText"
      :position="tooltipPosition"
    >
      <b-datepicker
        v-model="value"
        v-validate="validate"
        :name="name"
        data-vv-validate-on="change"
        class="rex-date"
        :class="{
          'rex-date--is-disabled': isDisabled,
          'rex-date--has-error': errors.first(name) || error
        }"
        :placeholder="placeholder"
        :min-date="minDate"
        :max-date="maxDate"
        :disabled="isDisabled"
        :loading="isLoading"
        :position="position"
        :selectable-dates="selectableDates"
        :unselectable-dates="unselectableDates"
        :unselectable-days-of-week="unselectableDaysOfWeek"
        :range="isRange"
        :events="events"
        indicators="bars"
      >
        <div v-if="events.length">
          <div
            v-for="(item, index) in legend"
            :key="index"
            class="rex-date__legend-item"
          >
            <div
              class="rex-date__legend-item-color"
              :style="{
                'background-color': item.color
              }"
            />
            <p class="rex-date__legend-item-label">
              {{ item.label }}
            </p>
          </div>
        </div>
      </b-datepicker>
    </b-tooltip>
  </b-field>
</template>